import { Eye, EyeOff, Lock } from 'lucide-react';
import { useState } from 'react';

// Password input wrapping the shared .form-field / .input-icon-wrap styling with
// a reveal-eye toggle. Reveal state is per-field and always defaults to hidden.
// Accepts `children` so callers can render a strength meter / match hint below.
export default function PasswordField({
  id,
  label,
  value,
  onChange,
  autoComplete = 'new-password',
  labelExtra,
  children,
}) {
  const [revealed, setRevealed] = useState(false);
  const toggleLabel = revealed ? 'Hide password' : 'Show password';

  return (
    <div className="form-field">
      {label ? (
        labelExtra ? (
          <div className="label-split">
            <label htmlFor={id}>{label}</label>
            {labelExtra}
          </div>
        ) : (
          <label htmlFor={id}>{label}</label>
        )
      ) : null}
      <div className="input-icon-wrap pw-wrap">
        <Lock size={16} />
        <input
          id={id}
          name={id}
          type={revealed ? 'text' : 'password'}
          autoComplete={autoComplete}
          value={value}
          onChange={onChange}
          required
        />
        <button
          type="button"
          className="pw-toggle"
          onClick={() => setRevealed((prev) => !prev)}
          aria-label={toggleLabel}
          aria-pressed={revealed}
          title={toggleLabel}
        >
          {revealed ? <EyeOff size={16} /> : <Eye size={16} />}
        </button>
      </div>
      {children}
    </div>
  );
}
